module.exports = __webpack_public_path__ + "img/145.fe05b808.jpg";